import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../../hooks/use-services.hook";
import {PrimaryButtonBox} from "../../basic-componentes/primary-button.box";

const ButtonBox = styled(PrimaryButtonBox)`
    padding: 12px 12px;
    min-width: 156px;
    font-size: ${props => props.theme.fontSize.xLarge};
    border-radius: 28px;
`

const ButtonContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`

const ButtonLeftSection = styled.div`
    flex-grow: 1;
`

const ButtonRightSection = styled.div`
    margin-right: 4px;
`


export const SearchButtonComponent: React.FC = observer(() => {
    const services = useServices();
    const onClickHandler = async () => {
        await services.flightSearch.startBooking();
    }
    return (
        <ButtonContainerBox>
            <ButtonLeftSection/>
            <ButtonRightSection>
                <ButtonBox onClick={onClickHandler}>
                    {services.language.translate('Book now')}
                </ButtonBox>
            </ButtonRightSection>
        </ButtonContainerBox>
    )
});
